import UNINITIALISED from "utils/uninitialised";
import {MaybeUninitialised} from "modules/redux_types";
import {WorkflowTestsFetchAction} from "../actions/workflow_tests_fetch";
import actionTypes from "../constants/action_types";
import {AggregatedWorkflowTest} from "common/flowmaster/types/test";

export default function workflowsReducer(
  state: MaybeUninitialised<AggregatedWorkflowTest[]> = UNINITIALISED,
  action: WorkflowTestsFetchAction,
): typeof state {
  if (action.type === actionTypes.WORKFLOW_TESTS_FETCH.SUCCESS) {
    return (action as WorkflowTestsFetchAction).payload;
  }
  return state;
}
